<div id="wrapper">
    <app-loading-screen [status]=false></app-loading-screen>
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>

    <div>
        <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event" (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event" (updateCurrentList)="this.currentList=$event"
            (updateSelectBan)="this.selectBan=$event" (updateInitializeData)="this.initializeData()"></app-tab-nav>
    </div>
    <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
    <div class="basicrow">
        <div class="basicrow">
            <div class="container">
                <div class="fulltitle m-top-i f-btitle logo">
                    <span><img class="cclub-icon" src="../assets/images/icon_claro club_3-01.png"
                            style="width: 64px;height: auto;"> </span>
                    <div class="mtop">
                        <img class="logo-cc" width="160px" src="../assets/images/Claro club_logo.png">
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow m-top">
            <div class="container">
                <a class="webW"><img width="100%" src="../assets/images/CLARO-CLUB-BUREA-BANNER-1440x5401.jpg"></a>
                <a class="movilB"><img width="100%" src="../assets/images/CLARO-CLUB-BUREA-BANNER-375x234.jpg"></a>
            </div>
        </div>
        <div class="basicrow m-top lessm">
            <div class="container">
                <div class="basicrow m-top-i">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 roboto-l f-black text-justify">
                            <span class="f-big less-f">&#191;Qu&eacute; es Claro Club&#63;</span><br /><br />
                            <span class="f-reg-i f-mgray">
                                Programa de lealtad exclusivo para clientes de Claro que ofrecen recompensas en
                                restaurantes, entretenimiento, servicios, belleza y mucho m&aacute;s. El cliente de
                                Claro acumula dinero en compras realizadas en comercios que participen en Claro Club.
                            </span>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 text-center h-mtop">
                            <img width="100%" src="../assets/images/nueva imagen_claro club-01.jpg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow m-top graybg">
            <div class="container">
                <div class="basicrow roboto-r f-reg f-black">
                    <div class="container">
                        <app-collapse [(content)]="this.content" [color]="this.color"></app-collapse>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow m-top-i">
            <div class="container mob-p-bot">
                <div class="basicrow m-top m-bott aux">
                    <div class="basicrow f-big roboto-l f-black">
                        &#191;Necesitas Ayuda&#63;
                    </div>

                    <div class="basicrow m-top-i">
                        <div class="row refdef">
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                <div class="basicrow text-center">
                                    <img width="100%" class="ref-icons" src="../assets/images/netflixicon1.png">
                                </div>

                                <div class="basicrow f-black roboto-r f-reg text-center m-top">
                                    <div class="basicrow f-bmed roboto-b">
                                        T&eacute;rminos y Condiciones
                                    </div>

                                    <div class="basicrow m-top">
                                        <!-- Lorem ipsum dolor sit amet, cons -->
                                        <!-- <br/><br/> -->

                                        <a routerLink="/club_terms" class="linkdefs">Ver Detalle&nbsp;&nbsp;<i
                                                class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 hrefmtop">
                                <div class="basicrow text-center">
                                    <img width="100%" class="ref-icons" src="../assets/images/ico_preguntasFrecuentes.png">
                                </div>

                                <div class="basicrow f-black roboto-r f-reg text-center m-top">
                                    <div class="basicrow f-bmed roboto-b">
                                        Preguntas Frecuentes
                                    </div>

                                    <div class="basicrow m-top">
                                        <!-- Lorem ipsum dolor sit amet, cons
                                        <br/><br/> -->

                                        <a routerLink="/club_questions" ui-sref="club_questions" class="linkdefs">Ver
                                            Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>